import Notifications from 'expo-notifications';
import { isWeb } from 'shared/constants/platform';
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

export const requestNotificationPermissions = async () => {
  try {
    const status = isWeb
      ? { granted: false }
      : await Notifications.getPermissionsAsync();
    return status;
  } catch {
    logBreadcrumb({
      level: 'error',
      message: 'Notification status error',
    });
  }
  return { granted: false };
};
